import { render, staticRenderFns } from "./upload-image-cropper.vue?vue&type=template&id=b4be67c4&"
import script from "./upload-image-cropper.vue?vue&type=script&lang=js&"
export * from "./upload-image-cropper.vue?vue&type=script&lang=js&"
import style0 from "./upload-image-cropper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports